
import { AssetTypeEntityDecoratorBase } from './asset-type.decorator.base';


export class AssetTypeEntityDecorator extends AssetTypeEntityDecoratorBase {
  constructor() {
    super();
  }
}



